// extracted by mini-css-extract-plugin
export default {"formInputStatus":"Editview_formInputStatus__IBiQX","titleH1":"Editview_titleH1__3qaB6","errorText":"Editview_errorText__ixguq"};